import { useState } from "react";
import ChangeInformationModal from "../components/modal/change-information";
import { useUser } from "../context/UserContext";
import AccountLayout from "../layouts/AccountLayout"
import './../styles/change-information.css';

export const ChangeInformation = () => {
  const { user, setUser } = useUser();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <AccountLayout title={"Thay đổi thông tin của bạn"}>
      <ChangeInformationModal
        user={user}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        setUser={setUser}
      />

      <section className="cinfo-shell">
        <header className="cinfo-head">
          <h1 className="cinfo-title">Cập nhật thông tin</h1>
          <p className="cinfo-subtitle">Kiểm tra và chỉnh sửa thông tin cá nhân để bảo mật tài khoản tốt hơn.</p>
        </header>

        <div className="cinfo-layout">
          <aside className="cinfo-avatar-card">
            <p className="cinfo-label">Ảnh đại diện</p>
            <img className="cinfo-avatar-image" src={user?.profileImg} alt="Ảnh đại diện" />
            <button onClick={() => setIsModalOpen(true)} className="cinfo-edit-btn cinfo-edit-btn--mobile" type="button">
              Sửa thông tin
            </button>
          </aside>

          <article className="cinfo-details-card">
            <div className="cinfo-details-head">
              <p className="cinfo-details-title">Thông tin chung</p>
              <button onClick={() => setIsModalOpen(true)} className="cinfo-edit-btn" type="button">
                Sửa thông tin
              </button>
            </div>

            <div className="cinfo-list">
              <InfoRow label="Họ và tên" value={user?.fullName || "Chưa có"} />
              <InfoRow label="Tên đăng nhập" value={user?.username || "Chưa có"} />
              <InfoRow label="Email" value={user?.email || "Chưa có"} />
              <InfoRow label="Số điện thoại" value={user?.phone || "Chưa có"} />
            </div>
          </article>
        </div>
      </section>
    </AccountLayout>
  );
};

const InfoRow = ({ label, value }) => {
  return (
    <div className="cinfo-row">
      <p className="cinfo-row-label">{label}</p>
      <span className="cinfo-row-value">{value}</span>
    </div>
  );
};
